setTimeout(() => {
      const element = document.querySelector('.cartitems');
if(element){
    const observer = new MutationObserver((MutationList) => {
        for(let item of MutationList){
            if(item.target.className.includes('free-shipping-bar ')){
        console.log(123)
        BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
            }
        }
    })
    observer.observe(element, {childList: true, subtree: true})
}


//add to cart
const atcBtn = document.querySelector('[data-product-atc]');
if(atcBtn){
    atcBtn.addEventListener('click', () => {
        setTimeout(() => {
            const checkoutBtn = document.querySelector('.atc-banner__form button[bss-b2b-cart-trigger-added][name="checkout"]');
            if(checkoutBtn){
                checkoutBtn.removeAttribute('bss-b2b-cart-trigger-added')
                BSS_B2B.observer.cartSubject.listenCartCheckout();
            }
        }, 2000)
    })
}
}, 300)